import React from "react"
import styles from "../../RaiseTicketForm.module.scss"
import SearchInputV2 from "../../../../components/SearchInputV2/SearchInputV2"
import usePocDetails from "./usePocDetails"
import { FormPageProps } from "../.."

const SpocDetails = ({ handleNextStep, handleCloseForm, module, redirectPage }: FormPageProps) => {
    const { formik, isAddSurveyLoading, isAddDemolitionLoading } = usePocDetails(handleNextStep, module!, redirectPage)

    return (
        <>
            <div className={styles.page_container} style={{ maxHeight: 500, overflow: "auto" }}>
                <div className={styles.page_section}>
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Name*</div>
                            <div className={styles.section_body}>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder="Enter Name"
                                    searchIcon={false}
                                    onSearch={(value: string) => formik.setFieldValue("name", value)}
                                    value={formik.values.name}
                                    type="text"
                                    height="44px"
                                    error={formik.touched.name && !!formik.errors.name}
                                    showError={formik.touched.name && !!formik.errors.name}
                                    errorText={formik.errors.name}
                                />
                            </div>
                        </div>
                        <div className="width-100p">
                            <div className={styles.section_header}>Contact Number*</div>
                            <div className={styles.section_body}>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder="Enter Contact Number"
                                    searchIcon={false}
                                    onSearch={(value: string) => formik.setFieldValue("contact_number", value)}
                                    value={formik.values.contact_number}
                                    type="number"
                                    height="44px"
                                    maxCharacter={10}
                                    error={formik.touched.contact_number && !!formik.errors.contact_number}
                                    showError={formik.touched.contact_number && !!formik.errors.contact_number}
                                    errorText={formik.errors.contact_number}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div className={styles.section_header}>Email ID</div>
                            <div className={styles.section_body}>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder="Enter Email ID"
                                    searchIcon={false}
                                    onSearch={(value: string) => formik.setFieldValue("email", value)}
                                    value={formik.values.email}
                                    type="text"
                                    height="44px"
                                    error={formik.touched.email && !!formik.errors.email}
                                    showError={formik.touched.email && !!formik.errors.email}
                                    errorText={formik.errors.email}
                                />
                            </div>
                        </div>
                        <div className="width-100p"></div>
                    </div>
                </div>
            </div>
            <footer className="raise-ticket-form__footer">
                <button type="button" className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button
                    onClick={() => formik.handleSubmit()}
                    className="raise-ticket-form__footer-button next-btn"
                    disabled={isAddSurveyLoading || isAddDemolitionLoading}>
                    Submit
                </button>
            </footer>
        </>
    )
}

export default SpocDetails
